import { render } from "./RidSddBanche.vue?vue&type=template&id=6776967e&scoped=true"
import script from "./RidSddBanche.vue?vue&type=script&lang=js"
export * from "./RidSddBanche.vue?vue&type=script&lang=js"

import "./rid-sdd-banche-comune.css?vue&type=style&index=0&id=6776967e&scoped=true&lang=css"
import "./RidSddBanche.vue?vue&type=style&index=1&id=6776967e&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6776967e"]])

export default __exports__